// src/api.js
import axios from "axios";
import router from "@/router";

const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Attach token to each request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ✅ Global response handler
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // 🔴 Clear invalid token
      localStorage.removeItem("token");

      // 🔒 Ensure user is not able to access protected routes
      const currentPath = router.currentRoute.value.path;
      if (
        !["/login", "/signup", "/forgot-password", "/404"].includes(currentPath)
      ) {
        router.replace("/login");
      }
    }
    return Promise.reject(error);
  },
);

export default api;
